module.exports = __webpack_public_path__ + "assets/f4384f14350651f0fe5afa8e8f300286.jpg";